/**
 * @author caijianjia
 * @date 2020/3/14 5:21 下午
 */
// npm i js-audio-recorder
// 录音功能【https://github.com/2fps/recorder】
import Recorder from 'js-audio-recorder';
import {Message} from "element-ui";
import lamejs from "lamejs";

let instance = null

/**
 * 实例化话录音
 * @param obj 【配置参数】
 * {
    sampleBits: 16,         // 采样位数，支持 8 或 16，默认是16
    sampleRate: 16000,      // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
    numChannels: 1,         // 声道，支持 1 或 2， 默认是1
    compiling: false,       // 是否边录边转换，默认是false
    }
 */
export function initAudioRecorder(obj){
    instance = new Recorder(obj);
}

/**
 * 开始录音
 * @param callback 回调函数
 */
export function audioRecorderStart(callback){
    if(!instance) initAudioRecorder()
    instance.start().then((res) => {
        // 开始录音
        callback(res)
    }, (error) => {
        // 出错了
        console.log(`${error.name} : ${error.message}`);
        Message.warning('当前设备不支持录音,请检查麦克风是否已接入')
    });
}

/**
 * 暂停录音
 */
export function audioRecorderPause(){
    instance.pause();
}

/**
 * 继续录音
 */
export function audioRecorderResume(){
    instance.resume();
}

/**
 * 结束录音
 */
export function audioRecorderStop(){
    instance.stop();
}

/**
 * 播放录音
 */
export function audioRecorderPlay(){
    instance.play();
}

/**
 * 获取播放录音时长
 */
export function audioRecorderGetPlayTime(){
    console.log(1111, instance.getPlayTime())
    return instance.getPlayTime();
}

/**
 * 暂停录音播放
 */
export function audioRecorderPausePlay(){
    instance.pausePlay();
}

/**
 * 暂停录音播放
 */
export function audioRecorderResumePlay(){
    instance.resumePlay();
}

/**
 * 停止播放
 */
export function audioRecorderStopPlay(){
    instance.stopPlay();
}

/**
 * 销毁实例
 */
export function audioRecorderDestroy(){
    instance.destroy().then(function() {
        instance = null;
    });
}

/**
 * 直接获取录音数据 【获取 PCM 数据】
 */
export function audioRecorderGetPCMBlob(){
    return instance.getPCMBlob();
}

/**
 * 直接获取录音数据 【获取 WAV 数据】
 */
export function audioRecorderGetWAVBlob(){
    return instance.getWAVBlob();
}

/**
 * 直接获取录音数据 【获取 WAV 数据】
 */
export function audioRecorderGetWAV(){
    return instance.getWAV();
}

/**
 * 下载录音文件 【下载 PCM 格式】
 */
export function audioRecorderDownloadPCM({fileName}){
    return instance.downloadPCM(fileName);
}

/**
 * 下载录音文件 【下载 WAV 格式】
 */
export function audioRecorderDownloadWAV({fileName}){
    return instance.downloadWAV(fileName);
}

/**
 * 录音实时回调 获取录音数据
 *   录音时长（duration）。
     已录音文件大小(字节)（fileSize）。
     录音音量百分比（vol）。
     所有的录音数据（data）。
 */
export function audioRecorderOnprogress(callbak){
    instance.onprogress(function (params) {
        callbak(params)
    });
}

/**
 * 录音波形显示
 */
export function audioRecorderGetRecordAnalyseData(){
    return instance.getRecordAnalyseData();
}

/**
 * 播放外部音频文件
 */
export function audioRecorderPlayAudio({Blob}){
    return Recorder.playAudio(Blob);
}

/***
 * 获取mp3 数据流
 * @param wavDataView
 * @returns {Blob}
 */
export function convertToMp3(wavDataView) {
    if(!instance) initAudioRecorder()
    // 获取wav头信息
    const wav = lamejs.WavHeader.readHeader(wavDataView); // 此处其实可以不用去读wav头信息，毕竟有对应的config配置
    const { channels, sampleRate } = wav;
    const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128);
    // 获取左右通道数据
    const result = instance.getChannelData()
    const buffer = [];

    const leftData = result.left && new Int16Array(result.left.buffer, 0, result.left.byteLength / 2);
    const rightData = result.right && new Int16Array(result.right.buffer, 0, result.right.byteLength / 2);
    const remaining = leftData.length + (rightData ? rightData.length : 0);

    const maxSamples = 1152;
    for (let i = 0; i < remaining; i += maxSamples) {
        const left = leftData.subarray(i, i + maxSamples);
        let right = null;
        let mp3buf = null;

        if (channels === 2) {
            right = rightData.subarray(i, i + maxSamples);
            mp3buf = mp3enc.encodeBuffer(left, right);
        } else {
            mp3buf = mp3enc.encodeBuffer(left);
        }

        if (mp3buf.length > 0) {
            buffer.push(mp3buf);
        }
    }

    const enc = mp3enc.flush();

    if (enc.length > 0) {
        buffer.push(enc);
    }

    return new Blob(buffer, { type: 'audio/mp3' });
}
